/**
 * Give - Stripe Gateway Payment Request JS
 */

let stripe = {};

document.addEventListener( 'DOMContentLoaded', function() {
	// Get all the donation forms on a single page.
	const formWraps = document.querySelectorAll( '.give-form-wrap' );
	const prButton = [];
	const paymentRequest = [];
	const isPRButtonExists = [];
	let defaultGateway = '';
	const preferredLocale = give_stripe_vars.preferred_locale;

	// Loop through each donation form.
	Array.prototype.forEach.call( formWraps, function( formWrap ) {
		const form_element = formWrap.querySelector( '.give-form' );

		// Bailout, if `form_element` is null.
		if ( null === form_element ) {
			return;
		}

		const publishableKey = form_element.getAttribute( 'data-publishable-key' );
		const accountId = form_element.getAttribute( 'data-account' );
		const idPrefix = form_element.getAttribute( 'data-id' );

		/**
		 * Bailout, when publishable key is not present for a donation form
		 * due to Stripe account not properly attached to the form or global
		 * Stripe account is not added.
		 */
		if ( null === publishableKey ) {
			return;
		}

		stripe[ idPrefix ] = Stripe( publishableKey );

		if ( accountId.trim().length !== 0 ) {
			stripe[ idPrefix ] = Stripe( publishableKey, {
				stripeAccount: accountId,
			} );
		}

		const formID = form_element.querySelector('input[name=give-form-id]').value,
			  modalButton = formWrap.querySelector( '.give-btn-modal' ),
			  gridModalLauncher = document.querySelector( `#give-card-${formID}` ),
			  hasModalButton = null !== modalButton,
			  hasGridModalLauncher = null !== gridModalLauncher,
			  elements = stripe[ idPrefix ].elements( {
				  locale: preferredLocale,
			  } );

		if ( null !== form_element.querySelector( '.give-gateway-option-selected .give-gateway' ) ) {
			defaultGateway = form_element.querySelector( '.give-gateway-option-selected .give-gateway' ).value;
		}

		// Set default value for payment request button exists flag.
		isPRButtonExists[ idPrefix ] = false;

		// Set default gateway value on changing gateway.
		Array.prototype.forEach.call( form_element.querySelectorAll( '.give-gateway' ), function( gateway_element ) {
			gateway_element.addEventListener( 'change', function( e ) {
				if ( gateway_element.checked ) {
					defaultGateway = gateway_element.value;
				}
			} );
		} );

		// Prepare tabs and payment request button on gateway load.
		jQuery( document ).on( 'give_gateway_loaded', function( event, xhr, settings ) {
			if ( defaultGateway === 'stripe_google_pay' || defaultGateway === 'stripe_apple_pay' ) {
				preparePaymentRequestButton( idPrefix, elements );
			}
		} );

		// Remount payment button when open popup after first time (form grid mode, modal mode, button mode).
		if( hasModalButton ) {
			modalButton.addEventListener( 'click', reMountPaymentRequestButton );
		}

		if( hasGridModalLauncher ) {
			gridModalLauncher.addEventListener( 'click', reMountPaymentRequestButton );
		}

		// Remount payment button when donor redirect to form page after error.
		if (
			( Give.fn.getParameterByName( 'form-id' ) === form_element.querySelector( 'input[name=give-form-id]' ).value ) &&
			[ 'stripe_google_pay', 'stripe_apple_pay' ].includes( Give.fn.getParameterByName( 'payment-mode' ) ) &&
			( hasModalButton|| hasGridModalLauncher )
		) {
			let intitalPaymentRequestButtonsetup = window.setInterval( function() {
				if (jQuery.magnificPopup.instance.isOpen) {
					const $formFromPopup = document.getElementsByClassName( 'mfp-wrap' )[0]
						.getElementsByClassName( 'give-form' );

					if ($formFromPopup.length) {
						preparePaymentRequestButton( idPrefix, elements );
						window.clearTimeout( intitalPaymentRequestButtonsetup );
					}
				}
			}, 500 );
		} else {
			// Load custom events when default gateway is stripe on load.
			if ('stripe_google_pay' === defaultGateway || 'stripe_apple_pay' === defaultGateway) {
				preparePaymentRequestButton( idPrefix, elements );
			}
		}

		/**
		 * ReMount Payment request button
		 *
		 * @since 2.2.3
		 */
		function reMountPaymentRequestButton() {
			if (defaultGateway === 'stripe_google_pay' || defaultGateway === 'stripe_apple_pay') {
				if( 'undefined' !== typeof prButton[idPrefix]  ) {
					prButton[idPrefix].removeListener( 'click' );
					prButton[idPrefix].unmount( '#give-stripe-payment-request-button-' + idPrefix );
				}

				preparePaymentRequestButton( idPrefix, elements );
			}
		}

		/**
		 * Prepare Payment Request Button.
		 *
		 * @param {string} idPrefix ID Prefix.
		 * @param {object} elements Stripe Elements Object.
		 *
		 * @since 1.6
		 */
		function preparePaymentRequestButton( idPrefix, elements ) {
			const formName = form_element.querySelector( 'input[name="give-form-title"]' );
			let donationAmount = Give.fn.unFormatCurrency( form_element.querySelector( '.give-final-total-amount' ).dataset.total, form_element.dataset.decimal_separator );

			if( 'undefined' === typeof paymentRequest[ idPrefix ] ){
				// Setup the payment request with Stripe.
				paymentRequest[ idPrefix ] = stripe[ idPrefix ].paymentRequest( {
					country: give_stripe_vars.base_country,
					currency: form_element.getAttribute( 'data-currency_code' ).toLowerCase(),
					total: {
						label: formName.value,
						amount: Math.round( donationAmount * 100 ),
					},
					requestShipping: false,
					requestPayerName: true,
				} );


				// Add event.
				paymentRequest[ idPrefix ].on( 'paymentmethod', async( ev ) => {
					const billingDetails = ev.paymentMethod.billing_details;
					form_element.querySelector( 'input[name="give_stripe_payment_method"]' ).value = ev.paymentMethod.id;

					const cardCountryElement = document.createElement( 'input' );
					cardCountryElement.setAttribute( 'type', 'hidden' );
					cardCountryElement.setAttribute( 'name', 'billing_country' );
					form_element.appendChild( cardCountryElement ).value = billingDetails.address.country;

					const cardAddressElement = document.createElement( 'input' );
					cardAddressElement.setAttribute( 'type', 'hidden' );
					cardAddressElement.setAttribute( 'name', 'card_address' );
					form_element.appendChild( cardAddressElement ).value = billingDetails.address.line1;

					const cardAddress2Element = document.createElement( 'input' );
					cardAddress2Element.setAttribute( 'type', 'hidden' );
					cardAddress2Element.setAttribute( 'name', 'card_address_2' );
					form_element.appendChild( cardAddress2Element ).value = billingDetails.address.line2;

					const cardCityElement = document.createElement( 'input' );
					cardCityElement.setAttribute( 'type', 'hidden' );
					cardCityElement.setAttribute( 'name', 'card_city' );
					form_element.appendChild( cardCityElement ).value = billingDetails.address.city;

					const cardZipElement = document.createElement( 'input' );
					cardZipElement.setAttribute( 'type', 'hidden' );
					cardZipElement.setAttribute( 'name', 'card_zip' );
					form_element.appendChild( cardZipElement ).value = billingDetails.address.postal_code;

					const cardStateElement = document.createElement( 'input' );
					cardStateElement.setAttribute( 'type', 'hidden' );
					cardStateElement.setAttribute( 'name', 'card_state' );
					form_element.appendChild( cardStateElement ).value = billingDetails.address.state.toUpperCase();

					// Submit the form and complete.
					form_element.submit();
					ev.complete( 'success' );

				} );

			}

			// Check if the button exists, if it doesn't create it.
			if ( false === isPRButtonExists[ idPrefix ] ) {
				prButton[ idPrefix ] = elements.create(
					'paymentRequestButton',
					{
						paymentRequest: paymentRequest[ idPrefix ],
						style: {
							paymentRequestButton: {
								type: 'donate',
								theme: give_stripe_vars.payment_request_button_style,
								height: '64px',
							},
						},
					}
				);

				isPRButtonExists[ idPrefix ] = true;
			}

			// Check the availability of the Payment Request API first.
			paymentRequest[idPrefix]
				.canMakePayment()
				.then( function( result ) {
					const paymentRequestButton = document.getElementById( 'give-stripe-payment-request-button-' + idPrefix );

					if (paymentRequestButton) {
						if (result) {
							prButton[idPrefix].mount( '#give-stripe-payment-request-button-' + idPrefix );
							isPRButtonExists[idPrefix] = true;
						}
						paymentRequestButton.style.display = 'block';
					}
				} );

			prButton[idPrefix].on( 'click', function( evt ) {
				const verifyPayment = new XMLHttpRequest();
				const formData      = new FormData( form_element );
				const errorElement  = form_element.querySelector( '#give-stripe-payment-errors-' + idPrefix );
				donationAmount      = Give.fn.unFormatCurrency( form_element.querySelector( '.give-final-total-amount' ).dataset.total, form_element.dataset.decimal_separator );

				formData.append( 'action', 'give_process_donation' );
				formData.append( 'give_ajax', true );

				paymentRequest[idPrefix].update( {
					currency: form_element.getAttribute( 'data-currency_code' ).toLowerCase(),
					total: {
						label: formName.value,
						amount: Math.round( donationAmount * 100 ),
					},
				} );

				// Do something on Ajax on state change.
				verifyPayment.onreadystatechange = function() {
					if (
						4 === this.readyState &&
						200 === this.status &&
						'success' !== this.responseText
					) {
						evt.preventDefault();
						errorElement.innerHTML = this.response;
					} else {
						errorElement.innerHTML = '';
					}
				};
				verifyPayment.open( 'POST', give_global_vars.ajaxurl, false );
				verifyPayment.send( formData );
			} );
		}

	} );
} );
